export const Task = {
    PHOTOGRAPHY: "Photography",
    PROFILING: "Profiling",
    MEASURING: "Measuring",
    CODING: "Coding",
    CODING_QA: "Coding QA",
    IMAGE_EDITING: "Image Editing",
    IMAGE_EDITING_QA: "Image Editing QA",
    FINAL_QA: "Final QA",
    SHIPMENT: "Shipment",
    CLIENT: "Client",
};

export const SourcePage = {
    "photography.standard": "photography",
    "scheduling.default": "profiling",
    "coding.standard": "coding",
    "coding.standard.a": "coding",
    "coding.standard.b": "coding",
    "coding.standard.detailed": "coding",
    "coding.standard.detailed.a": "coding",
    "coding.standard.detailed.b": "coding",
    "codingqa.standard": "codingqa",
    "imageediting.standard": "imageediting",
    "imageediting.premium": "imageediting",
    "imageeditingqa.standard": "imageeditingqa",
    "finalqa.standard": "finalqa",
    "shipment.standard": "shipment",
    "brandverifiedqa.standard": "brandverifiedqa",
};

export const CodingSource = {
    "coding.standard.detailed.a": "detailedcoding",
    "coding.standard.detailed.b": "detailedcoding",
    "coding.standard.detailed": "detailedcoding",
    "coding.standard.a": "standardcoding",
    "coding.standard.b": "standardcoding",
    "coding.standard": "coding",
    "codingqa.standard": "codingqa",
};

export const taskTypeToLabelMap = {
    duplicatestaging: "Duplicate Staging",
    "photography.standard": "Photography",
    "scheduling.default": "Profiling",
    "measuring.standard": "Measuring",
    "coding.standard": "Coding",
    "coding.standard.detailed.a": "Detailed Coder A",
    "coding.standard.detailed.b": "Detailed Coder B",
    "coding.standard.a": "Standard Coder A",
    "coding.standard.b": "Standard Coder B",
    "codingqa.standard": "Coding QA",
    "imageediting.standard": "Image Editing",
    "imageeditingqa.standard": "Image Editing QA",
    "finalqa.standard": "Final QA",
    "shipment.standard": "Shipment",
    "brandverifiedqa.standard": "Brand Verified QA",
};

export const TaskType = {
    PHOTOGRAPHY: "photography.standard",
    PROFILING: "scheduling.default",
    MEASURING: "measuring.standard",
    CODING: "coding.standard",
    CODING_QA: "codingqa.standard",
    IMAGE_EDITING: "imageediting.standard",
    IMAGE_EDITING_QA: "imageeditingqa.standard",
    FINAL_QA: "finalqa.standard",
    SHIPMENT: "shipment.standard",
    BRAND_VERIFIED_QA: "brandverifiedqa.standard",
};
